import React from 'react';
import './style.scss';
import useRoutesAddRoute from './hooks';
import Form from '../../../../../components/molecules/forms';
import BottomButton from '../../utils/BottomButton';
import MultipleClientForms from '../../utils/MultipleClientForms';
import AddHeader from '../../../../../components/layout/header/add';
import Button from '../../../../../components/molecules/buttons';

function RoutesAddSchedule(): React.ReactElement {
  const {
    driverList, formik, id, isLoading, routeList, updateDriver,
  } = useRoutesAddRoute();

  const renderHeader = () => (
    <div>
      <AddHeader
        primary={{ route: '/routes/schedule', title: 'Routes Scheduled' }}
        title={id ? 'Edit Schedule' : 'Add Schedule'}
      />
      <div className="fz-16 fw-bold mb-2 px-4 px-xl-5" style={{ marginLeft: '20px' }}>{id ? 'Edit Schedule Details' : 'Add Schedule Details'}</div>
    </div>
  );

  const renderFormRoute = () => (
    <div className="px-4 px-xl-5">
      <Form.ReactSelect.Default
        id="routeId"
        label="Choose Route"
        placeholder="Choose Route"
        options={routeList}
        value={routeList?.find((x: any) => x.value.toString() === formik.values.routeId.toString())}
        onChange={(e) => {
          if (e) {
            formik.setFieldValue('routeId', e.value);
            formik.setFieldValue('clients', e.clients);
            formik.setFieldValue('userId', e.driverId ?? '');
          }
        }}
        isInvalid={formik.touched.routeId && !!formik.errors.routeId}
        errorMsg={formik.errors.routeId}
        onBlur={formik.handleBlur}
        className="mb-4"
        disabled={!!id}
      />
      <div className="row">
        <div className="col-lg-6 mb-lg-0 mb-4">
          <Form.ReactSelect.Default
            id="userId"
            label="Choose Driver"
            placeholder="Choose Driver"
            options={driverList}
            value={driverList?.find((x: any) => x.value.toString() === formik.values.userId.toString())}
            onChange={(e) => {
              if (e) formik.setFieldValue('userId', e.value);
            }}
            isInvalid={formik.touched.userId && !!formik.errors.userId}
            errorMsg={formik.errors.userId}
            onBlur={formik.handleBlur}
            disabled={driverList === undefined}
          />
        </div>
        <div className="col-lg-6">
          <Form.ReactDatePicker
            id="datePicker"
            selectedDate={new Date(formik.values.scheduleDate)}
            handleChange={(date) => {
              console.log('Changing date...');
              console.log(date);
              if (date) formik.setFieldValue('scheduleDate', `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`);
            }}
            label="Select Date"
          />
        </div>
      </div>
      <div className="d-flex justify-content-end mt-4 flex-wrap">
        <div style={{ marginLeft: 20 }}>
          <Button.Default
            label="Update Date"
            style={{ minWidth: 200, display: id ? 'block' : 'none' }}
            disabled={!formik.values.scheduleDate && !formik.values.userId}
            onClick={updateDriver.submit}
            loading={updateDriver.load}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {renderHeader()}
      <form
        aria-label="form"
        onSubmit={formik.handleSubmit}
      >
        {renderFormRoute()}
        <div className="w-100 bg-stroke mt-5" style={{ height: '7px' }} />
        <MultipleClientForms formik={formik} id={id} />
        <div className="w-100 bg-stroke mt-4 mb-4" style={{ height: '7px' }} />
        <BottomButton loading={isLoading} />
      </form>
    </div>
  );
}

export default RoutesAddSchedule;
